module.exports = __webpack_public_path__ + "img/divider-white.80f1095a.svg";